import { toast } from 'react-toastify';
import { baseURL } from '../../services/api';

function getCookie(name: any) {
  let cookie: any = {};

  document.cookie.split(';').forEach(function (el) {
    let [k, v] = el.split('=');
    cookie[k.trim()] = v;
  });

  return cookie[name];
}

const DownloadXLSX = async (rota: string, filename?: string) => {
  const myCookie = getCookie('@Somos:access');
  const xlsxFileRoute = `${baseURL}${rota}`;

  try {
    const response = await fetch(xlsxFileRoute, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${myCookie}`,
      },
    });

    if (!response.ok) {
      let errorText = `Erro ao baixar arquivo (status: ${response.status})`;

      try {
        const rawText = await response.text();

        if (rawText) {
          try {
            const errorBody = JSON.parse(rawText);
            errorText =
              errorBody?.content ||
              errorBody?.message ||
              Object.values(errorBody)[0] ||
              rawText;
          } catch {
            errorText = rawText;
          }
        }
      } catch {
      }
      toast.error(errorText, { position: toast.POSITION.TOP_RIGHT });
      return (
        Promise.reject({
        status: response.status,
        message: errorText,
        })
     )
    }

    let filenameFromBack = 'arquivo.xlsx';

    const disposition = response.headers.get('content-disposition');
    if (disposition) {
      const filenameRegex = /filename\*=UTF-8''([^;]+)|filename="?([^"]+)"?/i;
      const match = disposition.match(filenameRegex);
      if (match) {
        filenameFromBack = decodeURIComponent(match[1] || match[2]);
      }
    }

    const finalFilename = filename || filenameFromBack;

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', finalFilename);
    document.body.appendChild(link);
    link.click();
    link.remove();

    window.URL.revokeObjectURL(url);

  } catch (err) {
    toast.error('Erro ao obter o arquivo xlsx', { position: toast.POSITION.TOP_RIGHT });
  }
};

export default DownloadXLSX;